import { FC, PropsWithChildren } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CssBaseline } from '@mui/material';

import { FeedbackProvider, LocalizationProvider, PermissionProvider } from '@cvt/contexts';
import { ThemeComponent } from '@cvt/theme/ThemeComponent';

import { SettingsConsumer, SettingsProvider } from '@shared/contexts';
import { queryClientConfig } from '@shared/query';

import { DialogProvider } from './contexts/DialogContext/DialogContext';
import { RoutingProvider } from './routing';



const queryClient = new QueryClient(queryClientConfig);

export const App: FC<PropsWithChildren> = ({ children }) => (
  <Router>
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider>
        <RoutingProvider>
          <SettingsProvider>
            <SettingsConsumer>
              {themeSettings => (
                <PermissionProvider>
                  <ThemeComponent settings={themeSettings}>
                    <FeedbackProvider>
                      <CssBaseline/>
                      <DialogProvider>
                        {children}
                      </DialogProvider>
                    </FeedbackProvider>
                  </ThemeComponent>
                </PermissionProvider>
              )}
            </SettingsConsumer>
          </SettingsProvider>
        </RoutingProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  </Router>
);
